import type { NodeDesignsRevision } from "../../schemas/index.ts";

export const getUndoRevision = (revisions: NodeDesignsRevision[]) => revisions.findLast((r) => !r.skip);

export const getUndoRevisionNo = (revisions: NodeDesignsRevision[]) => getUndoRevision(revisions)?.revision;
